(function ($) {

	var JdaSlideshow = function ($elem, options) {

		var resetFuse = function() {
			if ($fuseIndElem) {
				$fuseIndElem.stop().css({width: '100%'});
			}
		};

		var startFuse = function() {
			if ($fuseIndElem) $fuseIndElem.stop().animate({width: '0%'}, settings.waitDuration);
		};

		/*##################################################################
		// Init
		##################################################################*/

		var playInterval;
		var tempPauseTimeout;
		var slides = [];
		var totalSlides = 0;
		var currentSlideKey = 0;
		var base64ImageEncoding = 'data:image/jpeg;base64';
		var $fuseIndElem;

		var sizedUrl = function (imgUrl, width) {
		    var sizedUrl;
		    var embedded = imgUrl.indexOf(base64ImageEncoding) === 0;
		    if (embedded) {
		        sizedUrl = 'url(' + imgUrl + ')';
		    } else {
		        sizedUrl = 'url(' + imgUrl + '?width=' + width + ')';
		    }
		    return sizedUrl;
		}

		var playBtnHtml = [
			'<div class="play-btn play-btn-sm">',
				'<div class="play-btn-inner">',
					'<div class="play-img">',
						'<span aria-hidden="true" class="glyph glyph-play"></span>',
					'</div>',
					'<span class="play-text">Play</span>',
				'</div>',
			'</div>'
		].join('');

		var settings = $.extend({
			// These are the defaults.
			waitDuration: 3000,
			transitionDuration: 500,
			tempPauseDuration: 5000,
			onSlideStart: null,
			onSlideEnd: null,
			pagination: true,
			wrapClass: '',
			opacityEffect: false,
			backgroundSize: 'contain',
			videoSeedSelector: '.jda-bespoke-embed-seed',
			showFuse: false,
			showDescrs: true,
			showContent: true,
            sectionTitleText: 'Slideshow',
            prevSlideHelpText: 'Previous slide',
            nextSlideHelpText: 'Next slide',
            defaultAltText: 'An untitled image',
            mainImageText: 'An image with the caption: {0}',
            openImageText: 'Open image: {0}',
            openVideoText: 'Open video: {0}',
            useSwipeGestures: false,
			addGlobalEventFunction: function(eventKey, func) {
				if (eventKey == 'resize') {
					$(window).resize(function(e) {
						func(e);
					});
				}
				else if (eventKey == 'scroll') {
					$(window).scroll(function(e) {
						func(e);
					});
				} else {
					throw 'Invalid event event key: ' + eventKey;
				}
			}
		}, options);

		// get data from HTML attributes
		var auxSfx = '';
		var sizeSfxData = $elem.data('ss-size');
		if (sizeSfxData) settings.sizeSfx = sizeSfxData;
		var featuredMode = $elem.data('featured-mode');
		if (featuredMode) {
			auxSfx = ' jda-slideshow-featured-mode';
			settings.sizeSfx = sizeSfxData;
			settings.backgroundSize = 'cover';
			settings.showFuse = true;
			settings.pagination = false;
			settings.showDescrs = false;
		} else {
			auxSfx = ' jda-slideshow-nonfeatured-mode';
		}

		// massage data from js instantiation
		var opacityEffectSfx = settings.opacityEffect ? ' opacityEffect' : '';
		var bgSizeSfx = settings.backgroundSize ? (' bg-size-' + settings.backgroundSize) : ' bg-size-contain';
		var wrapClass = settings.wrapClass ? ' ' + settings.wrapClass : '';
		var sizeSfx = settings.sizeSfx ? ' jda-ss-size-' + settings.sizeSfx : '';

		// wrap
		$elem.wrap('<div class="jda-slideshow-slideshow' + auxSfx + opacityEffectSfx + bgSizeSfx + sizeSfx + '"></div>');
		$elem.wrap('<div class="jda-slideshow-custom-wrap' + wrapClass + '"></div>');
        $elem.addClass('jda-slideshow-slides-ul');
        $elem.attr('aria-label', settings.sectionTitleText);
        $elem.attr('role', 'region');
		if (settings.showDescrs) {
			var $descrsWrap = $('<ul class="jda-ss-descrs-wrap" aria-hidden="true"></ul>');
			$elem.parent().append($descrsWrap);
		}
		if (settings.showFuse) {
			var fuseHtml = [
				'<div class="fuse-wrap">',
					'<div class="fuse-ind">',
					'</div>',
				'</div>'
			];
			$elem.closest('.jda-slideshow-custom-wrap').prepend(fuseHtml.join(''));
			$fuseIndElem = $elem.closest('.jda-slideshow-custom-wrap').find('.fuse-ind');
			$fuseIndElem.css({width: '100%'});
			startFuse();
		}

		var slideshowWidth = $elem.parent().innerWidth();

		if (settings.pagination) {
			var $paginationDotUl = $('<ul class="jda-slideshow-pagination jda-slideshow-pagination-dot"></ul>');
			$elem.parent().append($paginationDotUl);
			var $paginationThumbUl = $('<ul class="jda-slideshow-pagination jda-slideshow-pagination-thumb"></ul>');
			$elem.parent().parent().append($paginationThumbUl);
		}

		$elem.find('li').each(function (liK, li) {

			// vars
			var $li = $(li);
			var $img = $li.find('.jda-ss-bg-seed');
            var altTextBase = $img.data('alt') || $li.find('.title').text() || settings.defaultAltText;
            var altText = settings.mainImageText.replace(/\{0\}/, altTextBase);
            var thisOpenImageText;
            if ($li.find('.jda-bespoke-embed-seed').length) {
                thisOpenImageText = settings.openVideoText.replace(/\{0\}/, altTextBase);
            } else {
                thisOpenImageText = settings.openImageText.replace(/\{0\}/, altTextBase);
            }
			var imgUrl;
            if ($img.length) {
                if ($img.data('type') === 'image') {
                    imgUrl = $img.data('src');
                } else {
                    // its an anchor tag, that is used to seed a video embed
                    imgUrl = false;
                }
            }
            var $videoSeedElem = $li.find(settings.videoSeedSelector);

			// replace img element with div element, if the img element is actually
			// an img element, and not an <a> element.
			if (imgUrl) {
				$img.remove();
                var $divImg = $([
                    '<div class="jda-bg-img" aria-role="img" aria-label="' + altText + '" title="' + altText + '" aria-hidden="true">',
                        '<img src="' + imgUrl + '" alt="' + altText + '" />',
                    '</div>'
                ].join(''));
			    $divImg.css({
			        backgroundImage: sizedUrl(imgUrl, 1024),
					width: slideshowWidth
				});
				$li.prepend($divImg);
			}

            // Ensure that video play button is not reachable unless that slide is currently being shown
            if ($videoSeedElem.length) {
                $videoSeedElem.on(EVENT_NAME__JDA_BESPOKE_EMBED__HTML_REPLACED, function (event, data) {
                    var $videoPlayBtn = data.$newElem.find('.play-btn-wrap');
                    var oldLabel = $videoPlayBtn.attr('aria-label');
                    var newLabel = oldLabel + ': ' + altTextBase;
                    $videoPlayBtn
                        .attr('aria-hidden', 'true')
                        .attr('tabindex', -1)
                        .attr('aria-label', newLabel);
                });
            }

			// wrap inner content
			var $content = $li.find('.ss-content');
			if ($content.length && settings.showContent) {
				$content.wrap('<div class="jda-slideshow-content"><div class="container"><div class="row"><div class="col-sm-12"></div></div></div></div>');
			} else {
				if ($content.length) {
					$content.remove();
				}
			}

			// move description html to descrs wrap
			var $descr = $li.find('.short-descr');
			var $descrElem = $('<li>' + $descr.html() + '</li>');
			if ($descr.length && settings.showDescrs) {
				$descrsWrap.append($descrElem);
			}
			$descrElem.data('slide-key', liK);
			$descrElem.addClass('slide-key' + liK);
			$descr.remove();
			if (liK == 0) {
				$descrElem.addClass('active');
			}

			// further li elem manipulation
			if (liK == 0) {
				currentSlideKey = liK;
				$li.addClass('active');
			}
			$li.data('slide-key', liK);
			$li.addClass('slide-key' + liK);

			// if pagination is desired...
			if (settings.pagination) {

				// pagination dot
				var $paginationDot = $('<li tabindex="0" class="jda-slideshow-pagination-item slide-key' + liK + '" data-slide-key="' + liK + '" aria-label="' + thisOpenImageText + '"></li>');
				if (liK == 0) {
					$paginationDot.addClass('active');
				}
                function dotSelectedCallback($li) {
                    var slideKey = $li.data('slide-key');
                    temporarilyPause();
                    goToSlide(slideKey, function() {
                        resetFuse();
                    });
                }
                $paginationDot.click(function () {
                    dotSelectedCallback($(this));
                });
                $paginationDot.keydown(function (e) {
                    if (e.keyCode == 13 || e.keyCode == 32) { // enter, space
                        dotSelectedCallback($(this));
                    }
                });
				$paginationDotUl.append($paginationDot);

                // pagination thumb
                var $paginationThumb = $('<li class="jda-slideshow-pagination-item slide-key' + liK + '" data-slide-key="' + liK + '"></li>');

                var $actualImage = $('<img alt="' + altText + '" />');

                // pagination thumb image
				var $paginationThumbImg = $('<button class="pagination-item-image" aria-label="' + thisOpenImageText + '"></button>');
				if (imgUrl) {
					$paginationThumbImg.css({
					    backgroundImage: sizedUrl(imgUrl, 120)
					});
                    $actualImage.attr('src', imgUrl);
				} else {
                    if ($videoSeedElem.length) {
                        $videoSeedElem.on(EVENT_NAME__JDA_BESPOKE_EMBED__THUMBNAIL_FOUND, function(event, data) {
                            $paginationThumbImg.css({
                                backgroundImage: 'url(' + data.thumbUrl + ')'
                            });
                            $actualImage.attr('src', data.thumbUrl);
                            $paginationThumbImg.append(playBtnHtml);
                        });
                    }
                }

                // Append pagination thumb image to pagination thumb
				$paginationThumb.append($paginationThumbImg);

                // Append actual image tag to pagination thumb, for the benfit of screen readers
                // $paginationThumb.append($actualImage);

                // pagination thumb (more)
				if (liK == 0) {
					$paginationThumb.addClass('active');
				}
				$paginationThumb.click(function () {
					var slideKey = $(this).data('slide-key');
					temporarilyPause();
					goToSlide(slideKey, function() {
						resetFuse();
					});
                });

                // append thumb to <ul> element
				$paginationThumbUl.append($paginationThumb);
			}

			slides[slides.length] = $li;
			totalSlides++;
		});

		if (totalSlides < 2) {
			$paginationDotUl.html('');
			$paginationThumbUl.html('');
		}

		/*##################################################################
		// Event listeners
		##################################################################*/

		var addGlobalEventFunction = function(eventKey, func) {
			settings.addGlobalEventFunction(eventKey, func);
		};

		addGlobalEventFunction('resize', function() {
			resize();
		});

        if (totalSlides > 1) {
            var $prev = $('<button class="prev-slide" aria-label="' + settings.prevSlideHelpText + '"></button>');
			var $next = $('<button class="next-slide" aria-label="' + settings.nextSlideHelpText + '"></button>');
			var goPrev = function() {
				temporarilyPause();
				goToPrevSlide(function() {
					resetFuse();
				});
			}
			var goNext = function() {
				temporarilyPause();
				goToNextSlide(function() {
					resetFuse();
				});
			}
			$elem.parent().append($prev);
			$elem.parent().append($next);
            if ($('body').hasClass('rtl')) {
                $prev.click(goNext);
                $next.click(goPrev);
                if (settings.useSwipeGestures) {
                    $elem.on('swipeleft', function (e) {
                        goPrev();
                    });
                    $elem.on('swiperight', function (e) {
                        goNext();
                    });
                }
            } else {
                $prev.click(goPrev);
                $next.click(goNext);
                if (settings.useSwipeGestures) {
                    $elem.on('swipeleft', function (e) {
                        goNext();
                    });
                    $elem.on('swiperight', function (e) {
                        goPrev();
                    });
                }
            }
        }

        $elem.find('.jda-bg-img').on('click', function () {
            var imgSrcRaw = $(this).css('backgroundImage');
            var imgSrc = imgSrcRaw.replace(/url\(("?)/, '');
            imgSrc = imgSrc.replace(/\)/, '');
            imgSrc = imgSrc.replace(/"/, '');

            // Remove the re-sizing argument
            imgSrc = imgSrc.split('?')[0];
            var modal = app.ui.uiPlugins.modal;
            modal.addModalClass('slideshow-image-preview-modal');
            modal.setCenterVertical(true);
            modal.setSize('lg');
            modal.setBodyImage(imgSrc);
            modal.show();
        });

		/*##################################################################
		// Methods
		##################################################################*/

		// Helpers
		//================================

		var resize = function() {
			pause();
			setWidth();
			alignSlide();
			play();
		};

		var absNeg = function(n) {
			return (n <= 0) ? n : Math.abs(n) - Math.abs(n) - Math.abs(n);
		};

		// Playback
		//================================

		var goToFirstSlide = function(callback) {
			goToSlide(0, callback);
		};

		var goToNextSlide = function(callback) {
			if (currentSlideKey < (totalSlides - 1)) {
				goToSlide(currentSlideKey + 1, callback);
			} else {
				goToSlide(0, callback);
			}
		};

		var goToPrevSlide = function(callback) {
			if (currentSlideKey > 0) {
				goToSlide(currentSlideKey - 1, callback);
			} else {
				goToSlide(totalSlides - 1, callback);
			}
		};

		var goToSlide = function(sKey, callback) {

            if (typeof JdaVideoTools !== 'undefined') {
                JdaVideoTools.embedManager.pauseAll();
            }

			var $listItems = $elem.find('li.slide-key' + sKey);
            var $listItemVideoElemPlayBtn = $listItems.find('.jda-bespoke-embed-wrap .play-btn-wrap');
			var $mainListItem = $elem.find('> li.slide-key' + sKey);
			if (typeof settings.onSlideStart === 'function') {
				settings.onSlideStart.call(null, $listItems);
			}
			var newOffset = absNeg(slideshowWidth * (sKey));
			$elem.stop().animate({
				left: newOffset
			}, settings.transitionDuration, 'swing', function () {

				resetFuse();
				startFuse();

				$elem.parent().parent().find('li').removeClass('active');
				$elem.parent().parent().find('ul.jda-ss-descrs-wrap > li.slide-key' + sKey).addClass('active').removeAttr('aria-hidden');
				$listItems.addClass('active');
                $elem.find('> li .jda-bg-img').attr('aria-hidden', 'true');
                $mainListItem.find('.jda-bg-img').removeAttr('aria-hidden');

                $elem.find('li .play-btn-wrap').attr('aria-hidden', 'true').attr('tabindex', -1);
                if ($listItemVideoElemPlayBtn.length) {
                    $listItemVideoElemPlayBtn.removeAttr('aria-hidden').attr('tabindex', 0);
                }

				if (settings.pagination) {
					var $paginationItem = $elem.parent().parent().find('ul.jda-slideshow-pagination li.slide-key' + sKey);
					$paginationItem.addClass('active');
				}

				currentSlideKey = sKey;
				if (typeof settings.onSlideEnd === 'function') {
					settings.onSlideEnd.call(null, $listItems);
				}

                var $playVideoBtn = $elem.find('li.active button.play-btn-wrap');
                if ($playVideoBtn.length) $playVideoBtn.focus();

				if (typeof callback !== 'undefined') {
					callback.call(null, $listItems);
				}

			});
		};

		var pause = function() {
			clearInterval(playInterval);
		};

		var play = function() {
			if (!settings.waitDuration) return;
			playInterval = setInterval(function () {
				goToNextSlide();
			}, settings.waitDuration);
		};

		var temporarilyPause = function() {
			clearInterval(playInterval);
			clearTimeout(tempPauseTimeout);
			tempPauseTimeout = setTimeout(function () {
				play();
				startFuse();
			}, settings.tempPauseDuration);
		};

		// Bitty gritty stuff
		//================================

		var setWidth = function() {
			slideshowWidth = $elem.parent().width();
			$elem.find('li').each(function (liK, li) {
				var $li = $(li);
				$li.css({
					width: slideshowWidth
				});
				$li.find('.jda-bg-img').css({
					width: slideshowWidth
				});
			});
		};

		var alignSlide = function() {
			currentOffset = slideshowWidth * (currentSlideKey);
			currentOffset = currentOffset - currentOffset - currentOffset;
			$elem.stop().css({
				left: currentOffset
			});
			clearTimeout(tempPauseTimeout);
		};

		/*##################################################################
		// Chaining / init
		##################################################################*/

		play();
		setTimeout(function() {
			resize();
            goToFirstSlide();
		}, 100);
		return this;
	}

	$.fn.jdaSlideshow = function(options) {
		return this.each(function () {
			(new JdaSlideshow($(this), options));
		});
	};

}(jQuery));
